import React,{useState,useEffect} from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button } from "@mui/material";
import "./ProjectMaster.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {getProjectMasterList,downloadCategory,editProjectMasterRow} from "../function-components/Redux/ProjectMasterSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import ModalPopup from './AddNewProjectModal';

const ProjectMaster = () => {
const dispatch = useDispatch();
const projectMasterList = useSelector((state) => state.projectMaster.projectMasterList);
const [page, setPage] = useState(1);
const PER_PAGE = 8;
const startIdx = (page - 1) * PER_PAGE;
const endIdx = startIdx + PER_PAGE;
const currentItems = projectMasterList.slice(startIdx,  endIdx);
const count = Math.ceil(projectMasterList.length / PER_PAGE);
const [projectName, setProjectName] = useState('');
const [teamName, setTeamName] = useState('');
const [open, setOpen] = useState(false);
const [status, setStatus] = useState('');
const [pjName, setPjName] = useState('');
const [stakeHolderName, setStakeHolderName] = useState('');
const [selectedDate, setSelectedDate] = useState(null);
const [selNo, setSelNo] = useState('');

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
 };

 const handleChange = (e, p) => {
  setPage(p);
 };
const theme = createTheme({
 typography: {
 fontFamily: "Graphik-Regular",
},
});

const useStyles = makeStyles({
  customSelect: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      boxShadow: 'none',
    },
  },
});

// Helper function to format serial number with leading zeros
function formatSerialNumber(number) {
  return String(number).padStart(2, '0');
}

useEffect(() => {
  dispatch(getProjectMasterList());
}, []);


const handleDownload = () => {
  dispatch(downloadCategory());
}


const handleDropDownChange = (event) => {
  setProjectName(event.target.value);
};


const handleDropDownTeamChange = (event) => {
  setTeamName(event.target.value);
}

const handleOpen = (prjName,stkHolderName) => {
  setOpen(true);
  setPjName(prjName);
  setStakeHolderName(stkHolderName);
}
const handleClose = () => {
  setOpen(false);
}

const handleEdit = (slNo, endDate, status) => {
  dispatch(editProjectMasterRow(slNo, endDate, status));
  handleClose();
 };
 
 
const classes = useStyles();

return(
        <>
        <div className="contentWrapper">
        <ThemeProvider theme={theme}>
        <Box sx={{width:"93.5%",margin:"auto",paddingTop:"60px"}}>
        <Grid container spacing={2} sx={{width: "100% !important",marginLeft: "0 !important"}}>
        <Grid  xs={10}>
        <Typography className="pageHeading">Project Control Center</Typography>
        </Grid>
        <Grid  xs={2} sx={{textAlignLast: "end"}}>
        <Button className="addNewProject_button">
        <ModalPopup/>
        </Button>
        </Grid>
        </Grid>
        <Grid container spacing={2} sx={{width: "100% !important",marginLeft: "0 !important", marginTop: "0px !important"}}>
          <Grid xs={1.5} className="select_project_grid">
            <Box className="buttonStyle">
            <img  src="/images/projectMaster/Icon material-list.png" alt="icon" className="select_project_icon"/>
            <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Project</InputLabel>
          <Select
          variant="outlined"
          className={classes.customSelect}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={projectName}
          label="Select Project"
          onChange={handleDropDownChange}
          >
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
        </Select>
        </FormControl>
        </Box>
        </Grid>
        <Grid xs={1.5} className="select_team_grid">
        <Box className="buttonStyle">
          <img  src="/images/projectMaster/Icon feather-users.png" alt="icon" className="select_project_icon"/>
          <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Team</InputLabel>
          <Select
          variant="outlined"
          className={classes.customSelect}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={teamName}
          label="Select Team"
          onChange={handleDropDownTeamChange}
          >
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
        </Select>
        </FormControl>
          </Box>
          </Grid>
          <Grid xs={9}></Grid>
        </Grid>
        </Box>
        <Box className="projectMaster_table">
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{fontWeight: "bold !important"}}>
            <TableCell align="left" sx={{width:"5%"}}>#SL</TableCell>
            <TableCell align="left" sx={{width:"20%"}}>Project name</TableCell>
            <TableCell align="left" sx={{width:"16%"}}>Stakeholder name</TableCell>
            <TableCell align="left" sx={{width:"12%"}}>Start date</TableCell>
            <TableCell align="left" sx={{width:"12%"}}>End date</TableCell>
            <TableCell align="left" sx={{width:"10%"}}>Track name</TableCell>
            <TableCell align="left" sx={{width:"15%"}}>Status</TableCell>
            <TableCell align="left" sx={{width:"10%"}}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentItems.length != 0 &&
           currentItems.map((row, index) =>{
            const serial = formatSerialNumber(index + 1 + (page - 1) * PER_PAGE);
            return (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell  scope="row" align="left">
                {serial}
                </TableCell>
                <TableCell align="left" className="coloumn_projectMaster_td2"> {row.projectName}</TableCell>
                <TableCell align="left">{row.stakeHolderName}</TableCell>
                <TableCell align="left">{row.startDate}</TableCell>
                <TableCell align="left">{row.endDate}</TableCell>
                <TableCell align="center">{row.trackName == "" ? "-": row.trackName}</TableCell>
                <TableCell align="left" className={row.status == 3 ? "status_completed" : row.status == 2 ? "status_inprogress" : "status_notStarted"}>
                  {row.status == 3 ? "Completed" : row.status == 2 ? "Inprocess" : "Yet to start"}</TableCell>
                <TableCell align="left">
                  <div className="action_section">
                    <img src="/images/projectMaster/Icon awesome-user-plus.png" alt="icon" className="action_icon"/>
                    <img src="/images/projectMaster/Icon material-playlist-add-check.png" alt="icon" className="action_icon2"/>
                    <img src="/images/projectMaster/Icon feather-edit.png" alt="icon" className="action_icon1"  onClick={() => {
                    handleOpen(row.projectName,row.stakeHolderName); setSelNo(row.slNo);}}/>
                  </div>
                </TableCell>
                <Modal
                hideBackdrop
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title2"
                aria-describedby="modal-modal-description2"
                className="active-modal"
                >
                  <Box sx={style}>
              <div>
               <Grid>
                <div className="modal_header_section">
                <h3 className="form_header">Edit Project</h3>
                <span className="form_close_btn_model" onClick={handleClose}>
                 <img
                  src="/images/projectMaster/Icon awesome-window-close.png"
                  alt="icon"
                  className="form_close_img"
                 />
                </span>
                </div>
                <div className="first_section">
                  <div>
                  <label className="form_label" for="projectName">
                  Project Name*
                 </label>
                 <TextField
                  fullWidth
                  multiline
                  id="projectName"
                  variant="outlined"
                  value={pjName}
                  disabled
                 />
                  </div>
                 <div>
                 <label className="form_label" for="stakeHolderName">
                  Stakeholder Name*
                 </label>
                 <TextField
                  fullWidth
                  multiline
                  variant="outlined"
                  className="form_input_textfield"
                  value={stakeHolderName}
                  disabled
                 />
                 </div>
                
                </div>
                <div className="first_section">
                  <div className="date_section">
                  <label className="form_label" for="endDate">
                 End date*
                 </label>
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker 
                 value={selectedDate}
                 onChange={(newValue) => setSelectedDate(newValue)}
                 inputFormat="DD/MM/YYYY"
                 minDate={dayjs(row.startDate, "DD/MM/YYYY").add(1, 'day')}
                 
                />
                 
                  </LocalizationProvider>
                  </div>
                 <div className="date_section">
                 <label className="form_label" for="status">
                  Status*
                 </label>
                 <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="">
                <em>Select</em>
              </MenuItem>
            <MenuItem value={1}>Yet to start </MenuItem>
            <MenuItem value={2}>Inprocess</MenuItem>
            <MenuItem value={3}>Completed</MenuItem>
            </Select>
            </FormControl>
                 </div>
                
                </div>
                <div className="btn-container">
                 <Button
                  // type="submit"
                  className="save_btn"
                  variant="contained"
                  onClick={()=> handleEdit(selNo,selectedDate.format("DD/MM/YYYY"),status)}
                 >
                  Save
                 </Button>
                </div>
               </Grid>
              </div>
             </Box>
                </Modal>
                </TableRow>
                )})}
        </TableBody>
        </Table>
        </TableContainer>
        <Stack className="pagination_stack">
        <div className="download_section">
          <img src="/images/projectMaster/Icon metro-file-excel.png" alt="download_icon" style={{cursor:"pointer"}} onClick={handleDownload}/>
          <span className="download_span">Generate Full Report</span>
        </div>
        <Pagination count={count} page={page} onChange={handleChange} color="secondary" />
       </Stack>
        </Box>
        </ThemeProvider>
        </div>
        </>
    )
}

export default ProjectMaster;